export const SECTION_TITLE =
  "TIỂU SỬ, CUỘC ĐỜI VÀ SỰ NGHIỆP CỦA CHỦ TỊCH HỒ CHÍ MINH";

export const SLIDERS = [
  {
    imgUrl: "https://mitc.edu.vn/wp-content/uploads/2026/05/Artboard-1-1.png",
    title: "",
    content: "",
  },
  {
    imgUrl:
      "https://edumedia.lamdongtructuyen.vn//Images/LDG/khoa.sgd/PHUQUY/1_639135057523248647.jpg",
    title: "",
    content: "",
  },
];

export const ITEMS = [
  {
    imgUrl:
      "https://res.cloudinary.com/yitute/image/upload/v1685247897/2022-2023/HCM/tieu-su-hcm_1_a1iqnw.webp",
    title: "",
  },
  {
    imgUrl:
      "https://res.cloudinary.com/yitute/image/upload/v1685247892/2022-2023/HCM/tieu-su-hcm_2_lemcnf.webp",
    title: "",
  },
  {
    imgUrl:
      "https://res.cloudinary.com/yitute/image/upload/v1685247893/2022-2023/HCM/tieu-su-hcm_3_hg7l6l.webp",
    title: "",
  },
  {
    imgUrl:
      "https://res.cloudinary.com/yitute/image/upload/v1685247897/2022-2023/HCM/tieu-su-hcm_4_e5ctla.webp",
    title: "",
    sid: "",
  },
  {
    imgUrl:
      "https://res.cloudinary.com/yitute/image/upload/v1685247892/2022-2023/HCM/tieu-su-hcm_5_qhriux.webp",
    title: "",
  },
  {
    imgUrl:
      "https://res.cloudinary.com/yitute/image/upload/v1685247892/2022-2023/HCM/tieu-su-hcm_6_pbqkn9.webp",
    title: "",
  },
  {
    imgUrl:
      "https://res.cloudinary.com/yitute/image/upload/v1685247892/2022-2023/HCM/tieu-su-hcm_7_ptxc6v.webp",
    title: "",
  },
];
